import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { columnZeroV0Schema } from './v0';
import { columnLegacyV0Schema } from '../legacy/entity';
import { migrateLegacyZeroToV0 } from '../legacy/migration';

export const ZeroColumnEntitySchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: columnZeroV0Schema },
    },
    latestVersion: 0,
    legacy: [{ name: 'web', schema: columnLegacyV0Schema, up: migrateLegacyZeroToV0 }],
});

export type ZeroColumn = InferredEntity<typeof ZeroColumnEntitySchema>;
